var exports = {
  "D": "xaee3c4fa--edf557--title",
};

module.exports = exports;
